{"id":"FavoriteItemsButton","prefabs":{"default":{"children":[{"component":"FavoriteItemsButton","options":"options:*"}]}}}